module.exports = __webpack_public_path__ + "static/media/chambers2021.ce5de308.jpg";